<!-- Sharegain mark, design "Combo" loader. Path data and timings are copied from the design artifact. -->
<svg class="mark" [style.height.px]="size" viewBox="-0.75 -0.75 46 61.5" aria-hidden="true" focusable="false">
  <defs>
    <linearGradient [attr.id]="ids.top" x1="36" y1="2" x2="9" y2="25" gradientUnits="userSpaceOnUse">
      <stop class="s-light" offset="0" />
      <stop class="s-deep" offset="1" />
    </linearGradient>
    <linearGradient [attr.id]="ids.bottom" x1="38" y1="34" x2="9" y2="58" gradientUnits="userSpaceOnUse">
      <stop class="s-deep" offset="0" />
      <stop class="s-light" offset="1" />
    </linearGradient>
    <linearGradient [attr.id]="ids.band" x1="5" y1="21" x2="37" y2="33.5" gradientUnits="userSpaceOnUse">
      <stop class="s-streak-edge" offset="0" />
      <stop class="s-streak" offset=".42" />
      <stop class="s-streak-mid" offset=".75" />
      <stop class="s-streak-edge" offset="1" />
    </linearGradient>
  </defs>
  <g class="spin">
    @if (animate) {
      <animateTransform
        attributeName="transform"
        type="rotate"
        dur="5.5s"
        repeatCount="indefinite"
        keyTimes="0;0.5818;0.9091;1"
        calcMode="spline"
        keySplines="0 0 1 1;.45 0 .55 1;0 0 1 1"
        values="0 22.25 30;0 22.25 30;360 22.25 30;360 22.25 30" />
    }
    <g class="top">
      <path
        [attr.fill]="'url(#' + ids.top + ')'"
        d="M5.5 21.2C1.5 19.5 0 17.5 0 15.5C0 7 10 0 22.25 0C34.5 0 44.5 7 44.5 15.5C44.5 21 37 25.5 30.5 29C22 26.5 12 23.5 5.5 21.2Z">
        @if (animate) {
          <animate
            attributeName="d"
            dur="5.5s"
            repeatCount="indefinite"
            keyTimes="0;0.5818;0.7455;0.9091;1"
            calcMode="spline"
            keySplines="0 0 1 1;.4 0 .6 1;.4 0 .6 1;0 0 1 1"
            values="M5.5 21.2C1.5 19.5 0 17.5 0 15.5C0 7 10 0 22.25 0C34.5 0 44.5 7 44.5 15.5C44.5 21 37 25.5 30.5 29C22 26.5 12 23.5 5.5 21.2Z;M5.5 21.2C1.5 19.5 0 17.5 0 15.5C0 7 10 0 22.25 0C34.5 0 44.5 7 44.5 15.5C44.5 21 37 25.5 30.5 29C22 26.5 12 23.5 5.5 21.2Z;M8.25 29.5C8.25 27.04 8.9 24.63 10.13 22.5C12.63 18.17 17.25 15.5 22.25 15.5C27.25 15.5 31.87 18.17 34.37 22.5C35.6 24.63 36.25 27.04 36.25 29.5C26.92 29.5 17.58 29.5 8.25 29.5Z;M5.5 21.2C1.5 19.5 0 17.5 0 15.5C0 7 10 0 22.25 0C34.5 0 44.5 7 44.5 15.5C44.5 21 37 25.5 30.5 29C22 26.5 12 23.5 5.5 21.2Z;M5.5 21.2C1.5 19.5 0 17.5 0 15.5C0 7 10 0 22.25 0C34.5 0 44.5 7 44.5 15.5C44.5 21 37 25.5 30.5 29C22 26.5 12 23.5 5.5 21.2Z" />
        }
      </path>
    </g>
    <g class="bottom">
      <path
        [attr.fill]="'url(#' + ids.bottom + ')'"
        d="M37 33.5C41 35.5 44.5 39.5 44.5 44.5C44.5 53 34.5 60 22.25 60C10 60 0 53 0 44.5C0 38.5 8.5 32.5 15 29.2C12 27.3 7.5 25 5.5 21.6C10 25.5 22 31 37 33.5Z">
        @if (animate) {
          <animate
            attributeName="d"
            dur="5.5s"
            repeatCount="indefinite"
            keyTimes="0;0.5818;0.7455;0.9091;1"
            calcMode="spline"
            keySplines="0 0 1 1;.4 0 .6 1;.4 0 .6 1;0 0 1 1"
            values="M37 33.5C41 35.5 44.5 39.5 44.5 44.5C44.5 53 34.5 60 22.25 60C10 60 0 53 0 44.5C0 38.5 8.5 32.5 15 29.2C12 27.3 7.5 25 5.5 21.6C10 25.5 22 31 37 33.5Z;M37 33.5C41 35.5 44.5 39.5 44.5 44.5C44.5 53 34.5 60 22.25 60C10 60 0 53 0 44.5C0 38.5 8.5 32.5 15 29.2C12 27.3 7.5 25 5.5 21.6C10 25.5 22 31 37 33.5Z;M36.25 30.5C36.25 32.96 35.6 35.37 34.37 37.5C31.87 41.83 27.25 44.5 22.25 44.5C17.25 44.5 12.63 41.83 10.13 37.5C8.9 35.37 8.25 32.96 8.25 30.5C10.25 30.5 12.25 30.5 14.25 30.5C21.58 30.5 28.92 30.5 36.25 30.5Z;M37 33.5C41 35.5 44.5 39.5 44.5 44.5C44.5 53 34.5 60 22.25 60C10 60 0 53 0 44.5C0 38.5 8.5 32.5 15 29.2C12 27.3 7.5 25 5.5 21.6C10 25.5 22 31 37 33.5Z;M37 33.5C41 35.5 44.5 39.5 44.5 44.5C44.5 53 34.5 60 22.25 60C10 60 0 53 0 44.5C0 38.5 8.5 32.5 15 29.2C12 27.3 7.5 25 5.5 21.6C10 25.5 22 31 37 33.5Z" />
        }
      </path>
    </g>
    <g class="band">
      <path [attr.fill]="'url(#' + ids.band + ')'" d="M5.5 21.2C12 23.5 22 26.5 30.5 29C33 30 35 31.5 37 33.5C22 31 10 25.5 5.5 21.2Z">
        @if (animate) {
          <animate
            attributeName="opacity"
            dur="5.5s"
            repeatCount="indefinite"
            keyTimes="0;0.5818;0.6455;0.8455;0.9091;1"
            calcMode="spline"
            keySplines="0 0 1 1;.4 0 .6 1;0 0 1 1;.4 0 .6 1;0 0 1 1"
            values="1;1;0;0;1;1" />
        }
      </path>
    </g>
  </g>
</svg>
